import { render, staticRenderFns } from "./DeleteInvitationPopup.vue?vue&type=template&id=a375b680&scoped=true&"
import script from "./DeleteInvitationPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteInvitationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteInvitationPopup.vue?vue&type=style&index=0&id=a375b680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a375b680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a375b680')) {
      api.createRecord('a375b680', component.options)
    } else {
      api.reload('a375b680', component.options)
    }
    module.hot.accept("./DeleteInvitationPopup.vue?vue&type=template&id=a375b680&scoped=true&", function () {
      api.rerender('a375b680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/DeleteInvitationPopup.vue"
export default component.exports